import { HubConnection } from '@microsoft/signalr';
import { logger } from '../../../lib/helpers';
import {
  HomeworkHubMessage,
  HomeworkKvEntryUpdateModel,
  HomeworkSimplePeerSignal
} from '../../homework/homework-models';

export type ExamTask = (connection: HubConnection) => Promise<HomeworkHubMessage>;

function echo(message: string): ExamTask {
  return (connection) => {
    logger.log('ExamkHub.echo');
    return connection.invoke<HomeworkHubMessage>(
      'echo', message);
  };
}

function joinAsTeacher(examId: number): ExamTask {
  return (connection) => {
    logger.log('ExamHub.joinAsTeacher');
    return connection.invoke<HomeworkHubMessage>('joinAsTeacher', examId);
  };
}

function joinAsStudent(examId: number): ExamTask {
  return (connection) => {
    logger.log('ExamHub.joinAsStudent');
    return connection.invoke<HomeworkHubMessage>('joinAsStudent', examId);
  };
}

function setCurrentPushableBlock(pushableBlockSnapshotId: number): ExamTask {
  return (connection) => {
    logger.log('ExamHub.setCurrentPushableBlock');
    return connection.invoke<HomeworkHubMessage>(
      'setCurrentPushableBlock', pushableBlockSnapshotId);
  };
}

function getKeyValuesPart(examId: number, changeStamps: readonly number[]): ExamTask {
  return (connection) => {
    logger.log('ExamHub.getKeyValuesPart');
    return connection.invoke<HomeworkHubMessage>(
      'getKeyValuesPart', examId, changeStamps);
  };
}

function updateKeyValues(examId: number, keyValues: readonly HomeworkKvEntryUpdateModel[]): ExamTask {
  return (connection) => {
    logger.log('ExamkHub.updateKeyValues', keyValues);
    return connection.invoke<HomeworkHubMessage>(
      'updateKeyValues', examId, keyValues);
  };
}

function simplePeerSignal(signal: HomeworkSimplePeerSignal): ExamTask {
  return (connection) => {
    logger.log('ExamkHub.simplePeerSignal', signal);
    return connection.invoke<HomeworkHubMessage>(
      'simplePeerSignal', signal);
  };
}

class ExamTasksClass {
  readonly echo = echo;
  readonly joinAsStudent = joinAsStudent;
  readonly joinAsTeacher = joinAsTeacher;
  readonly getKeyValuesPart = getKeyValuesPart;
  readonly updateKeyValues = updateKeyValues;
  readonly simplePeerSignal = simplePeerSignal;
}

export const ExamTasks = new ExamTasksClass();
